<div class="magic-box-rule-form-modal">
  <h2 md-dialog-title>{{ title }}</h2>
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <div *ngIf="!loading && rule !== undefined">
      <div class="wrapper-form">
        <div class="section-form left">
          <div *ngIf="editMode && !rule.id">
            <div class="listText">
              1) Select Language(s) & Channel(s) you want to apply the rule on
            </div>
            <br />
            <div class="AlignWrapper">
              <div>
                <md-select
                  [(ngModel)]="rule.languages"
                  [multiple]="true"
                  #languagesSelect="ngModel"
                  placeholder="Language(s)"
                >
                  <md-option
                    disabled="disabled"
                    style="margin-left: -36px; color: black"
                  >
                    <md-checkbox
                      name="selectAll"
                      style="margin-left: 4px"
                      color="accent"
                      (change)="
                        selectAllLanguages(
                          languagesSelect,
                          currentUser.languages,
                          $event
                        )
                      "
                      [checked]="allLanguagesSelected()"
                      >Select All</md-checkbox
                    >
                  </md-option>
                  <md-option
                    disabled="disabled"
                    style="margin-left: -36px; color: black"
                  >
                    <md-checkbox
                      name="popupCountries"
                      style="margin-left: 4px"
                      color="accent"
                      (change)="
                        selectPopupCountries(
                          languagesSelect,
                          currentUser.languages,
                          $event
                        )
                      "
                      [checked]="popupCountriesSelected()"
                      >10 countries</md-checkbox
                    >
                  </md-option>
                  <md-option
                    *ngFor="let language of currentUser.languages"
                    [value]="language.id"
                  >
                    {{ language.value }}
                  </md-option>
                </md-select>
              </div>
              <div>
                <md-select
                  [(ngModel)]="rule.channelGroup"
                  [multiple]="false"
                  placeholder="Channels"
                  (change)="selectChannelchange($event)"
                >
                  <md-option
                    *ngFor="let channelGroup of channelGroups"
                    [value]="channelGroup.id"
                    >{{ channelGroup.name }}
                  </md-option>
                </md-select>
              </div>
            </div>
          </div>
          <div *ngIf="!editMode || rule.id">
            <div>
              <md-select
                [(ngModel)]="rule.languages"
                [multiple]="true"
                #languagesSelect="ngModel"
                placeholder="Languages"
              >
                <md-option
                  disabled="disabled"
                  style="margin-left: -36px; color: black"
                >
                  <md-checkbox
                    name="selectAll"
                    style="margin-left: 4px"
                    color="accent"
                    (change)="
                      selectAllLanguages(
                        languagesSelect,
                        currentUser.languages,
                        $event
                      )
                    "
                    [checked]="allLanguagesSelected()"
                    >Select All</md-checkbox
                  >
                </md-option>
                <md-option
                  *ngFor="let language of currentUser.languages"
                  [value]="language.id"
                >
                  {{ language.value }}
                </md-option>
              </md-select>
            </div>
          </div>
          <div *ngIf="!editMode || (rule.id && rule.channelgroupName)">
            <hr />
            <b>Channel Group</b> :
            {{ rule.channelgroupName }}
          </div>
          <div *ngIf="editMode && !rule.id">
            <div class="listText">2) Select a destination</div>
            <div class="apply">
              <md2-select
                [(ngModel)]="rule.applyTo"
                (change)="checkPicture(rule.applyTo)"
                multiple="true"
              >
                <md2-option
                  *ngFor="let destination of destinations"
                  [value]="destination.value"
                  >{{ destination.value }}
                </md2-option>
              </md2-select>
            </div>
          </div>
          <div
            *ngIf="(!editMode || rule.id) && rule.destination.value.length > 0"
          >
            <b>SupportKind</b> {{ rule.destination.value }}
          </div>
          <div class="for" *ngIf="editMode && !rule.id">
            <div class="listText">3) Select a field</div>
            <div>
              <md-radio-group [(ngModel)]="rule.for">
                <md-radio-button
                  *ngFor="let field of filteredFields"
                  [value]="field.id"
                  >{{ field.value }}
                </md-radio-button>
                <md-radio-button [disabled]="!isFieldPicture" [value]="4"
                  >Picture
                </md-radio-button>
              </md-radio-group>
            </div>
          </div>
          <div
            *ngIf="
              (!editMode || rule.id) && fields && getFieldById(rule.field.id)
            "
          >
            <b>Field</b>
            {{ getFieldById(rule.field.id).value }}
          </div>
          <div>
            <div *ngIf="editMode && !rule.id">
              <div class="listText">
                4) Select the type of classification you want to base your rule
                on :
              </div>
              <br />
              <div class="AlignWrapper">
                <div class="Sport">Sport</div>
                <div>
                  <md-slide-toggle
                    [checked]="isNonSportiveClassif"
                    (change)="changeTypeClassification($event)"
                  >
                  </md-slide-toggle>
                </div>
                <div class="NonSport">Non Sport</div>
              </div>
              <div class="selectors">
                <app-list-selector
                  *ngFor="let type of filteredReferentialTypes"
                  [type]="type"
                  [multiple]="false"
                  [values]="[]"
                  [selected]="getFiltersSelectorValue(type)"
                  [includeMode]="true"
                  [nonSport]="isNonSportiveClassif"
                  (selectorUpdated)="selectorUpdated()"
                  #selector
                >
                </app-list-selector>
              </div>
            </div>
          </div>
          <div *ngIf="!editMode || rule.id">
            <div *ngFor="let type of referentialTypes">
              <div *ngIf="rule[type.value.toLowerCase()]">
                <b>{{ type.value }}</b> :
                {{ rule[type.value.toLowerCase()].value }}
              </div>
            </div>
          </div>
          <div *ngIf="(!editMode || rule.id) && rule.field">
            <b>Field</b> :
            {{ rule.field.value }}
          </div>
        </div>
        <div class="section-form right" *ngIf="rule.for !== 4">
          <h4>Rule</h4>
          <div class="toolbar-tinymce" *ngIf="editMode || viewMode">
            <div class="action">
              <button
                md-raised-button
                [color]="ifMode ? 'accent' : ''"
                (click)="toggleIfMode()"
              >
                IF
              </button>
            </div>
            <div class="items">
              <button
                md-raised-button
                [color]="ifMode ? 'accent' : ''"
                *ngFor="let item of items"
                (click)="itemClicked(item.valueRule)"
              >
                {{ item.value }}
              </button>
            </div>
          </div>
          <app-tinymce-editor
            #tinymce
            [toolbar]="false"
            [value]="rule.wysiwyg"
            elementId="magic-box-rule"
            [editMode]="editMode || viewMode"
            (onEditorKeyup)="createNativeRule($event)"
          ></app-tinymce-editor>
          <br />
          <div *ngIf="rule.value">
            <b>Raw rule</b> :
            <pre class="raw">{{ rule.value }}</pre>
          </div>
          <div *ngIf="rule.value">
            <h6>Overview ({{ possibilities }} combinations)</h6>
            <ul>
              <li *ngFor="let possibility of rule.overview">
                {{ possibility }}
              </li>
            </ul>
            <div *ngIf="rule.applyTo.includes('Popup Next')">
              <h6>Overview Short Tag</h6>
              <ul>
                <li *ngFor="let possibility of rule.overviewShort">
                  {{ possibility }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="loading-image" *ngIf="loadingImage">
          <app-spinner></app-spinner>
        </div>
        <div class="section-form right" *ngIf="rule.for === 4 && pictures">
          <md2-tabs [selectedIndex]="selectedIndex">
            <md2-tab
              label="Original"
              [active]="data.optional2 === 'Original'"
              *ngIf="editMode || viewMode"
            >
              <div class="actions">
                <form class="form" (submit)="getEquinoxePicture()">
                  <md-form-field>
                    <input
                      mdInput
                      name="equinox"
                      placeholder="Equinoxe Id"
                      [(ngModel)]="equinoxeTerm"
                      type="number"
                      max="999999999"
                    />
                  </md-form-field>
                  <button md-raised-button color="primary" type="submit">
                    Add
                  </button>
                </form>
                <div>
                  <button md-raised-button (click)="upload()">UPLOAD</button>
                </div>
              </div>
              <input
                id="file_upload_cropper"
                type="file"
                style="visibility: hidden; display: none"
                (change)="fileChange($event)"
              />
              <div (drop)="onDrop($event)" (dragover)="onDragOver($event)">
                <img
                  class="original"
                  *ngIf="getETTPictureByFormat('Original').pictureURL"
                  [src]="getETTPictureByFormat('Original').pictureURL"
                  (click)="upload()"
                />
              </div>
            </md2-tab>
            <md2-tab
              label="Original"
              [active]="data.optional2 === 'Original'"
              *ngIf="!editMode && !viewMode"
            >
              <img
                class="original"
                *ngIf="getETTPictureByFormat('Original')"
                [src]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
              />
            </md2-tab>
            <md2-tab
              label="16:9"
              [active]="data.optional2 === '16:9'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper169
                format="format_16_9"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('16:9').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
            <md2-tab
              label="4:3"
              [active]="data.optional2 === '4:3'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper43
                format="format_4_3"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('4:3').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
            <md2-tab
              label="3:4"
              [active]="data.optional2 === '3:4'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper34
                format="format_3_4"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('3:4').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
            <md2-tab
              label="140:303"
              [active]="data.optional2 === '140:303'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper140303
                format="format_140_303"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('140:303').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
            <md2-tab
              label="10:3"
              [active]="data.optional2 === '10:3'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper103
                format="format_10_3"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('10:3').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
            <md2-tab
              label="1:1"
              [active]="data.optional2 === '1:1'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper11
                format="format_1_1"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('1:1').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
            <md2-tab
              label="2:3"
              [active]="data.optional2 === '2:3'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper23
                format="format_2_3"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('2:3').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
            <md2-tab
              label="485:173"
              [active]="data.optional2 === '485:173'"
              *ngIf="getETTPictureByFormat('Original').pictureURL"
            >
              <app-picture-cropper
                *ngIf="getETTPictureByFormat('Original')"
                #cropper485173
                format="format_485_173"
                [url]="
                  getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob
                "
                [src]="getETTPictureByFormat('485:173').pictureURL"
                [editMode]="true"
              ></app-picture-cropper>
            </md2-tab>
          </md2-tabs>
        </div>
      </div>
    </div>
  </md-dialog-content>
  <md-dialog-actions>
    <div class="actions" *ngIf="!loading && rule !== undefined">
      <div>
        <button md-raised-button md-dialog-close>
          <md-icon>cancel</md-icon>
          Cancel
        </button>
      </div>
      <div>
        <button
          md-raised-button
          color="warn"
          (click)="deleteRule()"
          *ngIf="rule.id && editMode"
          [disabled]="!canDelete()"
        >
          <md-icon>delete</md-icon>
          Delete
        </button>
        <button
          md-raised-button
          color="primary"
          *ngIf="rule.id && editMode"
          (click)="duplicate()"
        >
          <md-icon>content_copy</md-icon>
          Duplicate
        </button>
        <button
          md-raised-button
          color="accent"
          [disabled]="!canSave($editMode)"
          *ngIf="editMode || viewMode"
          (click)="save()"
        >
          <md-icon>save</md-icon>
          <span *ngIf="rule.id">Update</span>
          <span *ngIf="!rule.id">Create</span>
        </button>
      </div>
    </div>
    <div class="actions" *ngIf="!editMode && !loading && rule !== undefined">
      <div></div>
      <div>
        <button md-raised-button md-dialog-close>
          <md-icon>cancel</md-icon>
          Cancel
        </button>
      </div>
    </div>
  </md-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/magic-box-rule-form/magic-box-rule-form.component.html